import React from "react";

export const initialModal = () => ({
  title: "Welcome to Color Match!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Can you recreate the target color?
      </div>
      <div className="modal-description-contents">
        <p>
          You’ll see two colors side by side: <strong>Guess Color</strong> and{" "}
          <strong>Target Color</strong>. Use the RGB sliders or number inputs to
          adjust your guess. When you’re happy with your blend, hit{" "}
          <strong>Submit</strong> to compare both colors and reveal your
          accuracy score.
        </p>
      </div>
      <div className="modal-description-footer">Can you get a perfect 100?</div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const resultModal = (guess, target, score) => ({
  title: "Your Result",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        🎯 <strong>Score:</strong> {score} / 100
      </div>
      <div className="modal-description-contents">
        <table
          style={{
            width: "100%",
            textAlign: "center",
            borderCollapse: "collapse",
            marginTop: "12px",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }} />
              <th
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                <span className="highlight-red">R</span>
              </th>
              <th
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                <span className="highlight-green">G</span>
              </th>
              <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                <span className="highlight-blue">B</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: "8px",
                  borderTop: "1px solid #eee",
                  fontWeight: "bold",
                }}
              >
                Guess
              </td>
              <td
                className="highlight-red"
                style={{ padding: "8px", borderRight: "1px solid #ccc" }}
              >
                {guess.r}
              </td>
              <td
                className="highlight-green"
                style={{ padding: "8px", borderRight: "1px solid #ccc" }}
              >
                {guess.g}
              </td>
              <td className="highlight-blue" style={{ padding: "8px" }}>
                {guess.b}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: "8px",
                  borderTop: "1px solid #eee",
                  fontWeight: "bold",
                }}
              >
                Target
              </td>
              <td
                className="highlight-red"
                style={{ padding: "8px", borderRight: "1px solid #ccc" }}
              >
                {target.r}
              </td>
              <td
                className="highlight-green"
                style={{ padding: "8px", borderRight: "1px solid #ccc" }}
              >
                {target.g}
              </td>
              <td className="highlight-blue" style={{ padding: "8px" }}>
                {target.b}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});
